import { ComponentPropsWithoutRef, FC, ReactNode, Ref } from 'react';
import classNames from 'classnames';

import styles from './BottomSheetBody.module.css';

export type BottomSheetBodyProps = {
  children?: ReactNode;
  className?: string;
  ref?: Ref<HTMLDivElement>;
} & Omit<ComponentPropsWithoutRef<'div'>, 'className'>;

/** Тело шторки со скроллом. */
const BottomSheetBody: FC<BottomSheetBodyProps> = ({ children, className, ref, ...rest }) => (
  <div
    ref={ref}
    {...rest}
    className={classNames(styles.body, className)}>
    {children}
  </div>
);

export default BottomSheetBody;
